import React, { useState, useEffect } from "react";
import { Tab, Nav, Container, Row, Col, Button, Form } from "react-bootstrap";
import jsDig from "utils/jsDig";

export default function CampaignBuilder(props) {
  const loadingSpinner = require("images/generate-spinner.gif");

  const buildCampaigns = () => {
    const selectedActId = $("#gads-account-picker").val();
    const buildBtn = $(".build-btn");
    buildBtn.html(`<img class="generate-spinner" src="/datapulse${loadingSpinner}" /> Building`);
    buildBtn.removeClass("btn-success");
    buildBtn.addClass("btn-building text-white");
    $.ajax({
      type: "POST",
      url: "/datapulse/campaign-builder/build-campaigns/",
      data: {
        account_id: selectedActId
      },
      success: function(response) {
        $('#results').text(response.message);
        buildBtn.html('<i class="fa fa-check text-white" aria-hidden="true"></i> Built');
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR, textStatus, errorThrown)
        $('#errors').html(`ERROR: ${errorThrown}<br>${JSON.parse(jqXHR.responseText).message}`);
        buildBtn.html('Build');
        buildBtn.removeClass("btn-building");
        buildBtn.addClass("btn-success");
      }
    });
  };

  return (
    <>
      <Container>
        <Row className="justify-content-center campaign-builder">
          <Col xs={12} className="text-center">
            <h1 className="mb-3">Campaign Builder</h1>
            <div className="cb-actions pb-4">
              <Form.Control size="md" as="select" name="gads-account" id="gads-account-picker" defaultValue="0">
                <option value="0" disabled hidden>
                  Choose Account
                </option>
                {props.google_ads_accounts ? props.google_ads_accounts.map((act) => {
                  return (
                    <React.Fragment key={`${act.id}-${act.name}`}>
                      <option value={act.id}>{`${act.id} - ${act.name}`}</option>
                    </React.Fragment>
                  );
                }) : (
                  <></>
                )}
              </Form.Control>
              <Button
                className="build-btn"
                variant="success"
                onClick={(e) => buildCampaigns()}
              >
                Build
              </Button>
            </div>
            <div className="text-left">
              <p>This is a tool designed to help automate some of the initial onboarding steps. Clicking the button above will automatically make the following changes in the account of your choice:</p>
              <ul>
                <li>
                  Create the following budgets (if they do not already exist):
                  <ul>
                    <li><b>Branded</b></li>
                    <li><b>Non-Brand</b></li>
                  </ul>
                </li>
                <li>
                  Create the following bid strategies (if they do not already exist):
                  <ul>
                    <li><b>Branded - BM - tCPA</b></li>
                    <li><b>Branded - EM - tCPA</b></li>
                    <li><b>Non-Brand - BM - tCPA</b></li>
                    <li><b>Non-Brand - EM - tCPA</b></li>
                  </ul>
                </li>
                <li>
                  Create the following Negative Keyword Lists (if they do not already exist):
                  <ul>
                    <li><b>Account-Wide</b></li>
                    <li><b>Brand Name - Apply To NB Campaigns</b></li>
                    <li><b>Branded - Apply To Branded Campaigns</b></li>
                    <li><b>Exact Match Keywords</b></li>
                  </ul>
                </li>
                <li>
                  Create the following campaigns (if they do not already exist):
                  <ul>
                    <li><b>Branded - EM</b></li>
                    <li><b>Branded - BM</b></li>
                    <li><b>Non-Brand - EM</b></li>
                    <li><b>Non-Brand - BM</b></li>
                  </ul>
                </li>
                <li>
                  <p>When the script creates new campaigns, it will apply the budget and bid strategy relevant to that campaign. It will also enable ad schedules & geo targeting for the USA and 50 states.</p>
                  <p>Pre-existing campaigns will not be modified.</p>
                </li>
                <li>
                  Negative keyword Lists will be applied to any campaign that matches the list above.
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} className="pt-3">
            <div id="results"></div>
            <div className="text-danger" id="errors"></div>
          </Col>
        </Row>
      </Container>
    </>
  )
}